<template>
  <v-autocomplete
    v-bind:value="value"
    v-on:change="handleChange"
    :items="formattedTeams"
    :label="label"
    hide-no-data
    item-text="fullName"
    item-value="id"
    multiple
    outlined
    :disabled="disabled"
    :rules="rules || []"
    :hide-details="hideDetails"
    :menu-props="{ closeOnContentClick: !multiple }"
    :readonly="readonly"
    ref="autocomplete"
    :dense="dense"
  >
    <template v-slot:selection="data">
      <team-chip
        :team="data.item"
        close
        v-on:close="remove(data.item)"
        v-on:click="remove(data.item)"
        :dense="dense"
        :disabled="disabled"
      ></team-chip>
    </template>
    <template v-slot:item="data">
      <team-chip :team="data.item" :dense="dense"></team-chip>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TeamAutocomplete",
  components: {},
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    multiple: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    rules: { type: Array },
    label: { type: String, default: "Search by department name" },
    hideDetails: { type: [Boolean, String], default: false },
    dense: { type: Boolean, default: false }
  },
  computed: {
    readonly() {
      if (this.multiple) {
        return false;
      }
      return this.value.filter(x => x != null).length == 1;
    },
    formattedTeams() {
      let list = this.teams;
      let teamIds = this.teams.map(x => x.id);
      (this.user.teams || []).forEach(item => {
        if (teamIds.indexOf(item.teamId) < 0) {
          list.push({
            id: item.teamId,
            name: item.teamName
          });
          teamIds.push(item.teamId);
        }
      });
      return list;
    },
    ...mapGetters({
      teams: "team/teams",
      user: "user/edit_user"
    })
  },
  created() {
    this.$store.dispatch("team/getTeams");
  },
  methods: {
    handleChange(e) {
      if (!this.multiple && e.length > 1) {
        e.shift();
      }
      this.$emit(
        "change-full",
        this.$refs.autocomplete.cachedItems.filter(x => e.indexOf(x.id) >= 0)
      );
      this.$emit("change", e);
      this.search = "";
    },
    remove(item) {
      let index = this.value.findIndex(cv => cv.id == item.id);
      if (index == -1) {
        index = this.value.findIndex(cv => cv == item.id);
      }
      if (index >= 0) this.value.splice(index, 1);
      this.handleChange(this.value);
    }
  }
};
</script>
